export default __webpack_public_path__ + "static/media/arrow-icon.0bd90a54.svg";